import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class BrandSignupPaymentMethodController extends Controller {
  @service('commands/company-commands') companyCommandService;
  @service('commands/stashed-data-commands') stashedDataCommandService;
  @service('commands/user-commands') userCommandService;
  @service('error-tracker') errorTracker;
  @service session;
  @service stripe;
  @service router;

  get isLoading() {
    return this.loadDirectAssignmentFreelancer.isRunning;
  }

  get assignmentFreelancer() {
    return this.loadDirectAssignmentFreelancer.last?.value ?? null;
  }

  @action
  onBackClicked() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__ABOUT_YOU);
  }

  @task
  *loadDirectAssignmentFreelancer(directAssignmentDraftUUID) {
    try {
      const directAssignmentDraft = yield this.stashedDataCommandService.getByUUID(directAssignmentDraftUUID);
      return yield this.userCommandService.getUser(directAssignmentDraft.sellerId);
    } catch (error) {
      this.errorTracker.error(error, this, `loadDirectAssignmentDraft failed for uuid ${directAssignmentDraftUUID}}.`);
    }
  }

  @task
  *addPaymentMethod(cardElement) {
    const { currentUser } = this.session;
    const { company } = currentUser;

    try {
      // this should always be atomic
      yield (async () => {
        const token = await this.stripe.createToken(cardElement);
        const card = await this.companyCommandService.addNewCardForCompany(company, token.id);
        await this.companyCommandService.makeCardDefault(card);
      })();
    } catch (error) {
      this.errorTracker.error(e, this, `error adding credit card to company [${company.id}] with user [${currentUser.id}]`);
      throw e;
    }

    yield this.session.loadCurrentUser();

    yield this.router
      .refresh(EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP)
      .catch(() => {});
  }
}

export default BrandSignupPaymentMethodController;
